import { PaperAirplane } from "@/dist/iconstrations"
import classNames from "classnames"
import { ReactNode } from "react"

interface StatusMessageProps {
    borderAccent: "border-blue-600" | "border-orange-600" | "border-yellow-600" | "border-pink-600" | "border-pink-800"
    headingAccent: "text-blue-600" | "text-orange-600" | "text-yellow-600" | "text-pink-600" | "text-pink-800"
    heading?: string
    children?: ReactNode
    type: "note" | "important" | "caution" | "warning" | "advisory" | "alert"
    className?: string
}

// Button styles (registering with Tailwind.)
'p-4 rounded-lg text-white shadow inline-block mt-4 mb-1' 

// Button colors
'bg-orange-600 bg-blue-600 bg-yellow-600 bg-pink-600 bg-pink-800 bg-orange-800 bg-yellow-800'

export const StatusMessage = ({borderAccent, headingAccent, heading, children, type, className}: StatusMessageProps) => {

    const icon = (type: StatusMessageProps["type"]) => {
        switch (type) {
            case "note":
                return <PaperAirplane className="mr-2" />
            default:
                return <></>
        }
    }

    return (
        <div className={classNames("border p-4 gap-4 pr-9 bg-white rounded my-3 shadow", borderAccent, className)}>
            <div>
                <div className="flex">
                    {icon(type)}
                    { heading && (
                        <div className={classNames("mb-2̧ font-bold font-display", headingAccent)}>{heading}</div>
                    )}
                </div>
            {children}
            </div>
        </div>
    )
}